<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("messages")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="messages">
                <div class="messages__header messages__header_no-gutters">
                  <div class="row justify-content-between">
                    <div class="col-auto"><router-link class="btn btn_link" to="/messages"><span class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="14" height="14" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-back"></use>
                          </svg></span><span class="btn__text">{{$t("back")}}</span></router-link></div>
                    <div class="col-auto">
                      <button class="btn btn_remove" type="button" @click.prevent.stop="confirmDelMessage" :aria-label='$t("deleteMessage")' data-target="#modal-remove-message" data-toggle="modal"><span class="btn__text">{{$t("delete")}}</span><span class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="14" height="14" aria-hidden="true">
                            <use xlink:href="#svg-icon-close"></use>
                          </svg></span></button>
                    </div>
                  </div>
                </div>
                <div class="messages__body">
                  <div class="message-block box bg-white">
                    <div class="message-block__header">
                      <div class="row justify-content-between">
                        <div class="col-12 col-md-auto">
                          <div class="message-block__subject color-green">{{getMessage.message_object.title}}</div>
                        </div>
                        <div class="col-12 col-md-auto">
                          <div class="row justify-content-between">
                            <div class="col-auto">
                              <div class="message-block__type color-gray">{{getMessage.message_object.type}}</div>
                            </div>
                            <div class="col-auto">
                              <div class="message-block__date color-gray">{{formatDate(getMessage.message_object.created_at)}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="message-block__body">
                      <div class="message-block__title section__title section__title_style3">{{getMessage.message_object.title}}</div>
                      <div class="message-block__descr section__description">
                        <p>{{removeHtmlTags(getMessage.message_object.content)}}</p>
                        <!-- <table>
                          <tbody>
                            <tr>
                              <th>Ваш новый тарифный план:</th>
                              <td>ТТС Box 3в1</td>
                            </tr>
                            <tr>
                              <th>Интернет:</th>
                              <td>до 100 Мбит/с</td>
                            </tr>
                            <tr>
                              <th>Телевидение:</th>
                              <td>110+ каналов</td>
                            </tr>
                            <tr>
                              <th>Телефония:</th>
                              <td>включена</td>
                            </tr>
                            <tr>
                              <th>Абонентская плата:</th>
                              <td>5 600 тенге/месяц</td>
                            </tr>
                          </tbody>
                        </table> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>

    <div class="modal fade modal_remove-message" ref="modalRemoveMessage" id="modal-remove-message" :aria-label='$t("deleteMessage")' tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("deleteMessage")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click.prevent="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="section__description color-green">
              <p>{{$t("deleteMessage")}} "{{getMessage.message_object.title}}"?</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6">
                  <button class="btn btn_default btn_green js-remove-message" @click.prevent="delMessage" type="button">{{$t("yes")}}</button>
                </div>
                <div class="col-12 col-md-6 order-last order-md-first">
                  <button class="btn btn_default btn_white" type="button" @click.prevent="closeModal" data-dismiss="modal">{{$t("not")}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageHeader from "@/components/PageHeader";
import ModalWindow from "@/components/UI/ModalWindow";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    PageHeader
  },
  methods: {
    ...mapMutations({
      setMessageId: 'messages/setMessageId',
    }),
    ...mapActions({
      deleteMessage: 'messages/deleteMessage',
      changeStatusMessage: 'messages/changeStatusMessage'
    }),
    confirmDelMessage() {
      this.$refs.modalRemoveMessage.classList.add('modal_show')
    },
    delMessage(){
      this.deleteMessage().then( () => {
        this.closeModal();
        this.$router.push({ name: 'messages' })
      })
    },
    closeModal(){
      document.getElementById('modal-remove-message').classList.remove('modal_show')
    },
    formatDate(dateStr) {
      let separatorIdx = dateStr.indexOf('T')
      let dateArr = dateStr.slice(0, separatorIdx).split('-')
      let date = `${dateArr[2]}.${dateArr[1]}.${dateArr[0]}`
      let time =  dateStr.substr(separatorIdx+1, 8)

      return `${date} ${time}`
    },
    removeHtmlTags(str) {
      return str.replace(/<[^>]*>/g, '');
    },
  },
  created() {
    this.setMessageId(this.$route.params.id);
  },
  mounted() {
    if(this.getMessage.status !== 2){
      this.changeStatusMessage({"status": 2})
    }
  },
  computed: {
    ...mapGetters({
      getMessage: 'messages/getMessage'
    })
  }
}
</script>
<style scoped>
.modal_show{
  display: block;
  opacity: 1;
  background: rgba(255,255,255,.5);
}
</style>